import type { Archetype, Scores } from '../data/types';
import { rankedArchetypes } from './scoring';

const ADJECTIVES: Record<Archetype, string> = {
  servant: 'devoted',
  devotee: 'holy',
  sensualist: 'silken',
  primal: 'feral',
  brat: 'wild',
  little: 'gentle',
};

const NOUNS: Record<Archetype, string> = {
  servant: 'servant',
  devotee: 'devotee',
  sensualist: 'sensualist',
  primal: 'primal',
  brat: 'brat',
  little: 'little',
};

/**
 * Suggest a poetic name based on the top two archetypes:
 *   "the <adjective from #2> <noun from #1>"
 * If top two are very close, lean into the hybrid feel.
 */
export function suggestName(scores: Scores): string {
  const ranked = rankedArchetypes(scores);
  const first = ranked[0];
  const second = ranked[1];
  if (!first) return 'the unnamed constellation';
  if (!second) return `the ${NOUNS[first]}`;

  const adj = ADJECTIVES[second];
  const noun = NOUNS[first];
  // Avoid awkward "the devoted servant" twins: tweak when they share root
  if (adj.startsWith(noun.slice(0, 3))) {
    return `the ${NOUNS[second]} ${NOUNS[first]}`;
  }
  return `the ${adj} ${noun}`;
}
